// TODO: probably replace with a package like https://www.npmjs.com/package/pluralize
export default function pluralise(word, isPlural=true) {
  return isPlural ? word + 's' : word;
}